namespace TabAurous.OMS {
    export interface VendorForm {
        PartyType: Serenity.StringEditor;
        PartyCode: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        LedgerName: Serenity.StringEditor;
        AccountGroupId: Serenity.DecimalEditor;
        TermId: Serenity.IntegerEditor;
        MailingName: Serenity.StringEditor;
        BillbyBill: Serenity.BooleanEditor;
        TaxRegType: Serenity.LookupEditor;
        GstVat: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        LbrFlag: Serenity.BooleanEditor;
        StnFlag: Serenity.BooleanEditor;
        LbrFromDate: Serenity.DateEditor;
        LbrToDate: Serenity.DateEditor;
        StnFromDate: Serenity.DateEditor;
        StnToDate: Serenity.DateEditor;
        CostPricegroupId: Serenity.LookupEditor;
        StnAddDisc: Serenity.DecimalEditor;
        StnAddMkp: Serenity.DecimalEditor;
        LbrPricegroupId: Serenity.LookupEditor;
        LbrAddDisc: Serenity.DecimalEditor;
        LbrAddMkp: Serenity.DecimalEditor;
        AddressDetails: AddressMasterEditor;
        ContactDetails: ContactDetailsEditor;
        Token: Serenity.StringEditor;
        APIEndpoint: Serenity.StringEditor;
        APIToken: Serenity.StringEditor;
        AutoCreateVoucherUsingAPI: Serenity.BooleanEditor;
        AutoPosting: Serenity.BooleanEditor;
    }

    export class VendorForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Vendor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!VendorForm.init)  {
                VendorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.DateEditor;
                var w6 = AddressMasterEditor;
                var w7 = ContactDetailsEditor;

                Q.initFormType(VendorForm, [
                    'PartyType', w0,
                    'PartyCode', w0,
                    'IsDisabled', w1,
                    'LedgerName', w0,
                    'AccountGroupId', w2,
                    'TermId', w3,
                    'MailingName', w0,
                    'BillbyBill', w1,
                    'TaxRegType', w4,
                    'GstVat', w0,
                    'Pan', w0,
                    'CurrencyId', w4,
                    'LbrFlag', w1,
                    'StnFlag', w1,
                    'LbrFromDate', w5,
                    'LbrToDate', w5,
                    'StnFromDate', w5,
                    'StnToDate', w5,
                    'CostPricegroupId', w4,
                    'StnAddDisc', w2,
                    'StnAddMkp', w2,
                    'LbrPricegroupId', w4,
                    'LbrAddDisc', w2,
                    'LbrAddMkp', w2,
                    'AddressDetails', w6,
                    'ContactDetails', w7,
                    'Token', w0,
                    'APIEndpoint', w0,
                    'APIToken', w0,
                    'AutoCreateVoucherUsingAPI', w1,
                    'AutoPosting', w1
                ]);
            }
        }
    }
}
